module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori@2x-143112552d2389e65df93221b49ac469.webp";